import React, { useState, useEffect } from "react";

import PageWrapper from "../components/PageWrapper";
import ProtectedRoute from "../components/ProtectedRoute";
import Labs from "../sections/landing4/Labs";
import LabDetail from "../sections/landing4/LabDetail";
import CTA from "../sections/landing4/CTA";
import { labs } from "../data/labs";
import { loadLabProgress } from "../lib/firebase";
import { useAuth } from "../context/AuthContext";
import Seo from "../components/Seo";
import Instructions from "../components/Instructions/Instructions";

const LabsPage = () => {
  const { user } = useAuth();
  const [selectedLab, setSelectedLab] = useState(null);
  const [completedLabs, setCompletedLabs] = useState([]);

  useEffect(() => {
    if (!user) {
      setCompletedLabs([]);
      return;
    }
    let cancelled = false;
    loadLabProgress(user.uid).then((data) => {
      if (cancelled) return;
      if (data?.completedLabs) setCompletedLabs(data.completedLabs);
    });
    return () => { cancelled = true; };
  }, [user]);

  const handleBack = async () => {
    setSelectedLab(null);
    if (user) {
      try {
        const data = await loadLabProgress(user.uid);
        if (data?.completedLabs) setCompletedLabs(data.completedLabs);
      } catch (err) {
        console.error("Failed to reload progress:", err);
      }
    }
  };

  if (selectedLab) {
    return (
      <PageWrapper>
        <ProtectedRoute requiredRole="public">
          <LabDetail lab={selectedLab} onBack={handleBack} />
        </ProtectedRoute>
      </PageWrapper>
    );
  }

  return (
    <>
      <Seo
        title="DevOps Labs — Hands-on Challenges"
        description="Practice DevOps the way you'll do it on the job. Linux, containers, Kubernetes, CI/CD, IaC, observability, security. Filter by difficulty and category."
        pathname="/labs"
        image="/images/og-labs.png"
      />
      <PageWrapper>
        <ProtectedRoute requiredRole="public">
          <Labs
            labs={labs}
            completedLabs={completedLabs}
            user={user}
            onSelectLab={setSelectedLab}
            instructions={
              <Instructions label="how to use the labs">
                <h4>What's here</h4>
                <p>
                  Hands-on DevOps challenges. Each lab is a sandboxed environment
                  where you build the thing — Kubernetes cluster, Terraform
                  module, CI pipeline, monitoring stack, etc.
                </p>

                <h4>How it works</h4>
                <ol>
                  <li>
                    Pick a lab from the grid below — filter by category or
                    difficulty.
                  </li>
                  <li>Click "Start lab" to open the sandbox in a new tab.</li>
                  <li>Follow the on-screen steps. Hints expand when you're stuck.</li>
                  <li>Submit when the verification checks pass.</li>
                </ol>

                <h4>Already studying a course?</h4>
                <p>
                  Each course in <a href="/academy">Academy</a> recommends the
                  labs that match its modules — pair them for the deepest
                  learning.
                </p>
              </Instructions>
            }
          />
        </ProtectedRoute>
        <CTA />
      </PageWrapper>
    </>
  );
};
export default LabsPage;
